import { useState } from "react";

import Attachment from "components/Attachment/Attachment";
import MenuReports from "componentsv2/menu/MenuReports";
import MenuActions from "componentsv2/menu/MenuActions";
import MenuWizard from "componentsv2/menu/wizard/MenuWizard";
import IconButton from "componentsv2/button/IconButton";
import {
  saveIcon,
  attachmentIcon,
  deleteIcon,
} from "componentsv2/button/IconButtonForm";
import { useStore } from "storev2/formStore";

const style = "flex py-1 w-full md:col-span-2 lg:col-span-2 xl:col-span-2";

function FormToolbar({ onSave, view, layout, storeId, onChangeView }) {
  // This component is repetead?, check ToolbarForm.jsx
  const { findRecord } = useStore();
  const { form_action, access } = layout;
  const record = findRecord(storeId);
  const [viewAttach, setViewAttach] = useState(false);
  let btnAttachment;
  let btnDelete;
  let btnSave;
  let btnReports;
  let btnActions;
  let btnWizards;
  if (form_action) {
    btnAttachment = form_action.includes("attachment");
    let accessEdit = true;
    let accessDelete = true;
    if (access?.delete) {
      // must return true or false depends of the record evaluation
      accessDelete = access.delete(record?.active);
    }
    if (accessDelete) {
      btnDelete = form_action.includes("delete");
    }
    if (access?.edit) {
      // must return true or false depends of the record evaluation
      accessEdit = access.edit(record?.active);
    }
    /***the save button is necessary when the user is filling out the form
     *  and wants to save the form so as not to lose all the information,
     * e.g., shipment internal  */
    if ((accessEdit && record?.active?.id > 0) || layout.display === "board") {
      btnSave = form_action.includes("edit");
    }
    btnReports = layout.reports;
    btnActions = layout.actions;
    btnWizards = layout.wizards;
  }

  function onAttachment() {
    setViewAttach(true);
  }

  function onDelete() {
    onSave("delete", [record]);
  }

  const toolbar =
    btnSave || btnAttachment || btnReports || btnDelete || btnActions;

  console.log("toolbar reportts....", layout.reports);
  return (
    <div id="form-toolbar" className={style}>
      <div
        className="flex mr-0 ml-auto my-auto gap-2 space-x-6"
        id="actions_modal"
      >
        {toolbar && (
          <div className="flex ml-auto mr-3 my-auto rounded-md px-3 space-x-3">
            {btnActions && (
              <MenuActions actions={layout.actions} record={record?.active} />
            )}
            {btnReports && (
              <MenuReports reports={layout.reports} record={record?.active} />
            )}
            {saveIcon(btnSave, onSave)}
            {attachmentIcon(btnAttachment, onAttachment)}
            {deleteIcon(btnDelete, onDelete)}
            {/* {btnWizards && <MenuWizard layout={layout} activeRecord={record} />}*/}
          </div>
        )}
      </div>
      {viewAttach && (
        <Attachment
          activeRecord={record}
          onClose={() => {
            setViewAttach(false);
          }}
          layout={layout}
          open={viewAttach}
        />
      )}
      {view !== "modal" && (
        <IconButton
          onClick={() => onChangeView("return")}
          color="lime"
          name="back"
          tooltip="board.button_back"
        />
      )}
    </div>
  );
}

export default FormToolbar;
